import { HierarchyOfLinkedComponentsWithDirection } from '@ardoq/data-model';
import {
  RawGraphNode2,
  TraversalAndGroupingResult,
  LoadedGraphWithViewpointMode,
} from '@ardoq/graph';
import { getRootItems } from '@ardoq/graph';
import { getAllPathsAsHierarchy } from 'traversals/getAllPathsAsHierarchy';

type GetGraphShapeForTraversalHierarchy = (args: {
  loadedGraph: LoadedGraphWithViewpointMode;
  traversalAndGroupingResult: TraversalAndGroupingResult;
  startSet: string[];
}) => {
  rootItems: RawGraphNode2[];
  graphAsHierarchy: Record<string, HierarchyOfLinkedComponentsWithDirection>;
};

const getGraphShapeForTraversalHierarchy: GetGraphShapeForTraversalHierarchy =
  ({ loadedGraph, traversalAndGroupingResult, startSet }) => {
    const graphAsHierarchy = getAllPathsAsHierarchy(
      loadedGraph.hierarchyDefinition
    );

    const { rootGroups, componentMap } = traversalAndGroupingResult;

    const rootItems = getRootItems({
      startSet,
      rootGroups,
      componentMap,
    });

    return {
      rootItems,
      graphAsHierarchy,
    };
  };

export { getGraphShapeForTraversalHierarchy };
